import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import { increment, removeFromCart } from "../redux/actions/cartAction";

const CartItem = ({item,handleDecrement,handleIncrement}) => {
  const dispatch = useDispatch();
 
  const removeFromCartHandler = (id) => {
    dispatch(removeFromCart(id));
  };


  return (
    <div>
      <td className="product-remove ">
        <div className="icon cursor d-flex align-items-center justify-content-center">
          <img
            onClick={() => removeFromCartHandler(item.product)}
            src={require("../../Asset/cart/Essentials/bin.png")}
            alt="Delete Icon"
          />
        </div>
      </td>
      <td className="product-thumbnail p-3">
        <Link to="">
          <div className="cart-img">
            <img src={item.image} alt="Product" />
          </div>
        </Link>
      </td>
      <td className="product-name ">
        {item.name}
        <br />
        By <span className="cl-pm">{item.artist}</span>,
        <span>size: {item.size}</span>
      </td>
      <td className="product-stock-status  ">
        <div className="d-flex align-items-center">
          <button
            className="btn text-white m-0 me-2"
            onClick={() => dispatch(increment(item.product))}
            
          >
            -
          </button>
          <input className="count_input py-1 " type="text" value={item.qty} />

          <button
            className="btn text-white m-0 ms-2 "
            onClick={() => handleIncrement(item.product)}
          >
            +
          </button>
        </div>
      </td>
      <td className="product-price">
        ${item.price * item.qty}
      </td>
    </div>
  );
};

export default CartItem;
